export type Size = "inline" | "default" | "full";

export type ISizeMap = {
  [key in Size]: string;
};

export const sizeMap: ISizeMap = {
  inline: "w-16",
  default: "w-80",
  full: "w-full",
};
